module.exports = __webpack_public_path__ + "static/intertec_clientProject-2bdd56a3101cf0d17997cd30fee92999.jpg";